<div class="top-section">
    <h6 class="heading mb-0 flex items-center"><span>{{ ss.texts()['common_focusTracker'] }}</span></h6>
    <div class="flex items-center gap-6">
        <span class="collab-icon-wrapper" (click)="addCollaborator()" role="button">
            <app-svg [name]="isCollab() ? 'users' : 'addUser'" [color]="ss.theme().color12"></app-svg>
            <span class="collab-badge" *ngIf="collabCount() > 0">{{ collabCount() }}</span>
        </span>
        <app-svg name="more" class="more-icon" [matMenuTriggerFor]="infoMenu" role="button"
            [color]="ss.theme().color12"></app-svg>

        <mat-menu yPosition="above" xPosition="before" #infoMenu="matMenu" class="me-menu info-menu ri-mt-2"
            xPosition="before">
            <button mat-menu-item (click)="openFeatureInfo()">
                <span class="text-14-400 color-8 flex items-center"><app-svg name="info" class="ri-pe-3"
                        [color]="ss.theme().color35"></app-svg>{{ ss.texts()['common_featureGuide'] }}</span>
            </button>
            <button mat-menu-item (click)="downloadImage()" *ngIf="hasEntriesToday()">
                <span class="text-14-400 color-8 flex items-center"><app-svg name="import" class="ri-pe-3"
                        [color]="ss.theme().color35"></app-svg>{{ ss.texts()['shareQrAndLink_download'] }}</span>
            </button>
            <button mat-menu-item (click)="addCollaborator()" class="common-menu-width" *ngIf="myFocus()">
                <span class="text-14-400 color-8 flex items-center"><app-svg name="users"
                        class="ri-me-3 flex items-center justify-center" [width]="'20px'" [height]="'20px'"
                        style="width: 24px; height: 24px;" [color]="ss.theme().color35"></app-svg>{{
                    ss.texts()['common_collaborate'] }}</span>
                @if(collabCount() !== 0){
                <div class="menu-collaborator-add">
                    <span class="color-35" [ngClass]="'collaborator-count'">{{ collabCount() }}</span>
                </div>
                }@else{
                <app-svg name="collaboratorAdd" class="flex items-center justify-center"
                    style="width: 18px; height: 18px;"></app-svg>
                }
            </button>
        </mat-menu>
        <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
    </div>
</div>
<div class="focus-level-select">
    <div class="focus-level flex justify-between items-center ri-p-4 ri-bb-1" *ngFor="let level of focusLevels"
        role="button" (click)="selectLevel(level)">
        <div class="">
            <p class="text-16-400 color-8 mb-0 ri-pb-2">{{ focusConfig()[level].title }} <span
                    class="text-12-400 color-12 level-badge">{{ ss.texts()[level === 1 ? 'common_level1' : level === 2
                    ? 'common_level2' : 'common_level3'] }}</span></p>
            <p class="text-12-400 color-7 mb-0">{{ focusConfig()[level].instruction }}</p>
        </div>
        <app-svg name="navRightArrow" [color]="ss.theme().color35"></app-svg>
    </div>
</div>